<template>
  <div class="wrap">
    <p>
      尊敬的用户，您好！     
    </p>
    <p>
      本系统为上海市居住证积分材料上传系统。注册地为浦东新区（不含临港新片区）的单位办理《上海市居住证》积分相关业务，请根据本系统提示进行申报。     
    </p>
    <p>
      一、 如您需要为本单位员工办理积分申请（新办），请先至上海市居住证积分办理系统（https://www.rsj.sh.gov.cn/jzzjf/）进行填报并完成申报后，再至本系统进行上传材料，在本系统提示“材料预审通过”后，请单位人事先行预约，再至现场窗口 （受理点一览表）递交申请材料原件及复印件进行核验。   
    </p>
    <p>
      二、如您需要办理的业务是单位新开户，单位信息变更，请先至上海市居住证积分办理系统（https://www.rsj.sh.gov.cn/jzzjf/）进行填报并完成申报后，直接至现场窗口 （受理点一览表）递交申请材料原件及复印件，材料齐全可当场办结。       
    </p>
    <p>
      三、 单位密码重置、 个人密码重置、 积分有效期内变更工作单位、 变更居住地址直接至现场窗口 （受理点一览表）递交申请材料原件及复印件，材料齐全可当场办结。     
    </p>
    <p>
      四、目前，上海市居住证积分续办全部进入网审，请至上海市居住证积分办理系统（https://www.rsj.sh.gov.cn/jzzjf/）进行填报并完成申报，无需在本系统上传资料。       
    </p>
    <p>
      <strong>特别说明</strong> ：如续办申请单位已审核通过并上报后，在申请人姓名后无“（网）”字，则说明未进入网审，需至现场提交积分续办材料（详情请见《上海市居住证》签注后积分确认）。     
    </p>
    <p class="read">
      <Checkbox v-model="single">
      </Checkbox>
      已阅读上述信息及《<span class="a" @click="open('《上海市居住证积分管理办法》')">提供虚假材料的法律责任</span>》和《<span class="a" @click="open('隐私政策')">隐私政策</span>》，并承诺了解上海市居住证积分管理有关规定，所填表格中的内容及提交的书面材料真实。
    </p>
    <div class="btn">
      <Button type="primary" :disabled="!disabled" @click="confirm()">已阅并确认<span v-show='!disabled'>({{second}}s)</span></Button>
    </div>

    <Modal v-model="modal" width="70%">
      <template #header>
        <h3 style="text-align: center;">{{title}}</h3>
      </template>
      <privacy-policy v-show="title=='隐私政策'" />
      <false-material v-show="title=='《上海市居住证积分管理办法》'" />
      <template #footer>
        <Button @click="close">关闭</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
import PrivacyPolicy from './privacyPolicy/index.vue'
import FalseMaterial from './falseMaterial/index.vue'
export default {
  components: {
    PrivacyPolicy,
    FalseMaterial,
  },
  data() {
    return {
      modal: false,
      single: false,
      second: 5,
      disabled: false,
      title: '',
    }
  },
  mounted() {
    let _this = this
    let timer = setInterval(() => {
      _this.second--
      if (_this.second <= 0) {
        _this.disabled = true
        clearInterval(timer)
        timer = null
      }
    }, 1000)
  },
  methods: {
    open(type) {
      this.modal = true
      this.title = type
    },
    close() {
      this.modal = false
      this.title = ''
    },
    confirm() {
      if (!this.single) {
        this.$Message.error({ background: true, content: '请勾选确认阅读上述信息', duration: 5 })
        return
      }

      this.$emit('confirm', true)
    },
  },
}
</script>
<style lang="less" scoped>
.wrap {
  width: 65%;
  margin: 50px auto;
}
.a {
  cursor: pointer;
}
.a:hover {
  color: #5cadff;
  text-decoration: underline;
}
p {
  padding-bottom: 15px;
  text-indent: 2rem;
  font-size: 16px;
}
.read {
  text-indent: 0rem;
  color: #2d8cf0;
}
.btn {
  display: flex;
  justify-content: center;
}
</style>